import { CHANGE_SET_NEW_ROW_KEY_PREFIX } from '@erp/rpc';

/**
 * The review grid's row keys, and what they say about a row. Ingest rows are
 * keyed `<linkId>:<dataId>[|...]`; rows the review adds carry a prefix, so a
 * save can route each edit and a cell rule can tell an add from a change.
 */

// Grid row keys for authored new rows: `new:<StagedNewRow id>`. Shared with
// cell comment anchors, which name a new row the same way.
const NEW_ROW_KEY_PREFIX = CHANGE_SET_NEW_ROW_KEY_PREFIX;

// Grid row keys for draft new rows: authored in the Add-row dialog but not
// yet saved. A draft is pure pending state — it becomes a StagedNewRow (a
// `new:` row) only when the user saves their edits.
const DRAFT_ROW_KEY_PREFIX = 'draft:';

export function isNewRowKey(rowKey: string): boolean {
  return rowKey.startsWith(NEW_ROW_KEY_PREFIX);
}

export function newRowKey(id: string): string {
  return `${NEW_ROW_KEY_PREFIX}${id}`;
}

export function newRowIdOf(rowKey: string): string {
  return rowKey.slice(NEW_ROW_KEY_PREFIX.length);
}

export function isDraftRowKey(rowKey: string): boolean {
  return rowKey.startsWith(DRAFT_ROW_KEY_PREFIX);
}

export function draftRowKey(id: string): string {
  return `${DRAFT_ROW_KEY_PREFIX}${id}`;
}

/**
 * Whether a row adds a record to the AS/400 (the upload's ADD mode, `I1`) or
 * changes one it already holds (CHANGE mode, `I2`).
 */
export type RowMode = 'add' | 'change';

/** A row the review authored (saved or still a draft) is an add. */
export function rowModeOf(rowKey: string): RowMode {
  return isNewRowKey(rowKey) || isDraftRowKey(rowKey) ? 'add' : 'change';
}
